import React, { useState, useEffect, useCallback } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { RefreshCw, Loader2, Clock } from 'lucide-react';
import { adminApi } from '../../lib/api';

const AuditTab: React.FC = () => {
  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchAudit = useCallback(async () => {
    setLoading(true);
    try {
      const data = await adminApi.auditTrail(100);
      setEvents((data as any).events || (data as any).trail || (Array.isArray(data) ? data : []));
    } catch (e) {
      console.error('Failed to fetch audit:', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAudit(); }, [fetchAudit]);

  if (loading) return <div className="flex items-center justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>;

  if (!Array.isArray(events) || events.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <Clock className="w-10 h-10 mx-auto mb-3 opacity-40" />
        <p className="text-sm">No audit events recorded</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">{events.length} audit events</p>
        <Button variant="outline" size="sm" onClick={fetchAudit}><RefreshCw className="w-4 h-4 mr-1" /> Refresh</Button>
      </div>

      <Card className="p-0 overflow-hidden">
        <div className="max-h-[500px] overflow-y-auto scrollbar-thin">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-card border-b">
              <tr>
                <th className="text-left px-3 py-2 font-medium text-muted-foreground w-[130px]">Time</th>
                <th className="text-left px-3 py-2 font-medium text-muted-foreground w-[90px]">Action</th>
                <th className="text-left px-3 py-2 font-medium text-muted-foreground w-[100px]">User</th>
                <th className="text-left px-3 py-2 font-medium text-muted-foreground">Details</th>
              </tr>
            </thead>
            <tbody>
              {events.map((evt, i) => (
                <tr key={i} className="border-b border-border/50 hover:bg-muted/30">
                  <td className="px-3 py-1.5 text-muted-foreground whitespace-nowrap">
                    {evt.timestamp ? new Date(evt.timestamp).toLocaleString() : '--'}
                  </td>
                  <td className="px-3 py-1.5">
                    <Badge variant="outline" className="text-[10px]">{evt.action || evt.event_type || '?'}</Badge>
                  </td>
                  <td className="px-3 py-1.5 text-muted-foreground truncate max-w-[100px]">{evt.user_id || evt.user || '--'}</td>
                  <td className="px-3 py-1.5 text-foreground truncate max-w-0">
                    {evt.entity || evt.details || evt.message || JSON.stringify(evt.changes || '')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};

export default AuditTab;
